import { resetBasicCalculations, setBasicIPRMethodologySelection, setBasicTDHDesiredPIP, setBasicWellIPRDepletionPressure, setBasicWellIPRFutureProdRate, setShowDepletionPlotInMainReport, setShowIPRPlotInMainReport } from "../../../store/calculation/calculation-output/basicCalculationSlice";
import { useAppDispatch } from "../../../store/hooks/StoreHooks";


const useBasicCalculationsFacade = () => {
  const dispatch = useAppDispatch();
  const resetBasicCals = () => {
    dispatch(resetBasicCalculations());
  };

  const updateBasicDesrdPIP = (payload: number) => {
    return dispatch(setBasicTDHDesiredPIP(payload));
  };

  const updateIPRSelection = (payload: string) => {
    return dispatch(setBasicIPRMethodologySelection(payload));
  };

  const updateBasicIPRDepletionPressure = (payload: number) => {
    return dispatch(setBasicWellIPRDepletionPressure(payload));
  };

  const updateBasicIPRFutureProdRate = (payload: number) => {
    return dispatch(setBasicWellIPRFutureProdRate(payload));
  };

  const updateShowIPRPlotInMainReport = (payload: boolean) => {
    return dispatch(setShowIPRPlotInMainReport(payload));
  };

  const updateShowDepletionPlotInMainReport = (payload: boolean) => {
    return dispatch(setShowDepletionPlotInMainReport(payload));
  };

  return {
    resetBasicCals,
    updateBasicDesrdPIP,
    updateIPRSelection,
    updateBasicIPRDepletionPressure,
    updateBasicIPRFutureProdRate,
    updateShowIPRPlotInMainReport,
    updateShowDepletionPlotInMainReport,
  };
};

export default useBasicCalculationsFacade;
